<template>
    <header class="header" id="header" ref="refHeader">
        <div class="header__left">
            <BurgerButton @click="$emit('change', true)" />
        </div>
        <div class="header__center" :class="{ 'header__center--authorized': isAuthReady && isAuthorized && isMobile }">
            <a class="header__logo-wrapper" data-voicetext="Логотип" href="/">
                <LogoRsv alt="Логотип Россия — страна возможностей" class="logo__icon header__logo" />
            </a>
        </div>

        <div class="header__right">
            <div class="header__icons">
                <div class="header__track-wrapper">
                    <router-link :to="{ name: 'track' }" class="header__track" data-voicetext="Трек развития">
                        <IconTrack class="icon-track" />
                    </router-link>
                    <IconPromoTrack class="icon-promo-track" v-if="isPromoTrack" />
                    <div class="header__track-close" @click="closePromoTrack" v-if="isPromoTrack">
                        <IconClose class="icon-close" />
                    </div>
                </div>
                <router-link
                    v-if="isAuthReady && isAuthorized"
                    class="header__ratings"
                    data-voicetext="Рейтинг лучших участников"
                    :to="{ name: 'account-ratings' }"
                >
                    <IconRating />
                </router-link>
                <a
                    v-show="!showSearch"
                    href="javascript:;"
                    data-voicetext="Версия для слабовидящих"
                    class="header__element header__search only-desktop no-wrap"
                    @click="$accessibility.toggle()"
                >
                    <IconGlasses class="header__icon-glasses" />
                </a>
            </div>
            <HeaderSearch
                v-if="isAuthReady && !isMobile"
                class="search"
                :is-active="showSearch"
                @active="showSearch = true"
                @close="showSearch = false"
            />
            <Buttons v-if="isAuthReady" class="header__buttons" />
        </div>

        <Sidebar :active="isMenuActive" @change="$emit('change', false)" />
    </header>
</template>

<script>
import { get } from '@/tools/http';
import HeaderSearch from './WideHeaderSearch';
import Buttons from './HeaderButtons';
import BurgerButton from '@/components/UI/buttons/BurgerButton';
import { mapMutations, mapGetters } from 'vuex';
import Sidebar from './Sidebar.vue';
import { Config, Connect, ConnectEvents } from '@vkontakte/superappkit';
import RefUser from '@/components/UI/ref-user-link/RefUser.vue';
import IconTrack from '@/components/UI/icons/IconTrack.vue';
import LogoRsv from '@/components/UI/icons/LogoRsv.vue';
import IconPromoTrack from '@/views/track/icons/IconPromoTrack.vue';
import IconClose from '@/views/track/icons/IconClose.vue';
import IconGlasses from '@/components/UI/icons/IconGlasses.vue';
import IconRating from '@/components/UI/icons/IconRating.vue';

const getters = ['isMobile', 'getCoinsData'];

const userGetters = ['isAuthReady', 'isAuthorized'];

const mutations = ['setHeaderHeight'];

export default {
    name: 'WideHeader',

    components: {
        Buttons,
        HeaderSearch,
        Sidebar,
        BurgerButton,
        IconTrack,
        LogoRsv,
        IconPromoTrack,
        IconClose,
        IconGlasses,
        IconRating,
    },

    model: {
        prop: 'isMenuActive',
        event: 'change',
    },

    props: {
        isMenuActive: Boolean,
    },

    data: () => ({
        showSearch: false,
        floatingOneTap: null,
        isPromoTrack: false,
        isRouteRatings: false,
        currentUser: null,
    }),

    watch: {
        $route(to) {
            this.$emit('change', false);
            if (to.name === 'track') {
                this.isPromoTrack = false;
            }
        },
        isAuthReady() {
            if (!this.isAuthorized && !this.isMobile) {
                this.showVkAuth();
            }
        },
    },

    mounted() {
        this.takeMeasurements();

        this.isPromoTrack = localStorage.getItem('isPromoTrack') === null;

        if (this.$route.name === 'track') {
            this.isPromoTrack = false;
        }
    },

    updated() {
        this.takeMeasurements();
    },

    computed: {
        ...mapGetters(getters),
        ...mapGetters('auth', userGetters),
        isNotTrack() {
            return this.$route.name !== 'track';
        },
    },

    methods: {
        ...mapMutations(mutations),

        takeMeasurements() {
            this.$nextTick(() => {
                if (!this.$refs.refHeader) {
                    console.log('Desktop header already removed!');
                    return;
                }
                const element = this.$refs.refHeader;
                if (element) {
                    const height = element.offsetHeight;
                    this.setHeaderHeight(height);
                }
            });
        },

        showVkAuth() {
            const rsvDomain = this.$apiRsvDomain();
            return;
            Config.init({
                appId: 7498329,
            });
            this.floatingOneTap = Connect.floatingOneTapAuth({
                callback: function (evt) {
                    const type = evt.type;
                    if (!type) {
                        return;
                    }
                    switch (type) {
                        case ConnectEvents.OneTapAuthEventsSDK.LOGIN_SUCCESS:
                            return window.location.replace(
                                `https://identity.${rsvDomain}/signin-vk?payload=${encodeURIComponent(
                                    JSON.stringify(evt.payload)
                                )}`
                            );
                        case ConnectEvents.OneTapAuthEventsSDK.FULL_AUTH_NEEDED:
                        case ConnectEvents.OneTapAuthEventsSDK.PHONE_VALIDATION_NEEDED:
                        case ConnectEvents.ButtonOneTapAuthEventsSDK.SHOW_LOGIN:
                            return Connect.redirectAuth({
                                url: `'https://identity.${rsvDomain}/signin-vk`,
                            });
                        case ConnectEvents.ButtonOneTapAuthEventsSDK.SHOW_LOGIN_OPTIONS:
                            return Connect.redirectAuth({
                                url: `'https://identity.${rsvDomain}/signin-vk`,
                            });
                    }
                    return;
                },
                options: {
                    showAlternativeLogin: true,
                    showAgreements: false,
                    showAgreementsDialog: true,
                    displayMode: 'default',
                },
            });
            if (this.floatingOneTap) {
                const frame = this.floatingOneTap.getFrame();
                frame.style.zIndex = 999;
                document.body.appendChild(frame);
            }
        },

        closePromoTrack(event) {
            event.stopPropagation();
            this.isPromoTrack = false;
            localStorage.setItem('isPromoTrack', 'false');
        },
    },

};
</script>

<style lang="scss" scoped>
@import '../../styles/rem';

a {
    color: var(--color-primary);
}

.wrap_slabovid_butns {
    min-height: 48px;
    margin: 10px;
    padding: 2px;
    border-radius: 4px;
    background: var(--color-primary);
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--color-white);
}

.wrap_slabovid_butns_off {
    min-height: 48px;
    margin: 10px;
    padding: 2px 15px;
    border: 1px solid;
    background: var(--color-white);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.button_slabovid {
    font-family: 'Proxima Nova', sans-serif;
    padding-left: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 24px;
    text-align: center;
    color: var(--color-white);
}

.header {
    width: 100vw;
    height: mrem(49);
    padding: 0 mrem(16);
    display: flex;
    position: fixed;
    z-index: 999;
    top: 0;
    font-family: 'Montserrat', sans-serif;
    box-shadow: 0 urem(2) urem(8) rgba(155, 161, 166, 0.23626);

    @include on-desktop {
        height: rem(81);
        padding: 0 rem(40) 0 rem(156);
        box-shadow: 0px 2px 4px rgba(155, 161, 166, 0.15);
    }

    &__ratings {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        cursor: pointer;

        svg {
            width: mrem(32);
            height: mrem(32);
        }

        @include on-desktop {
            svg {
                width: rem(48);
                height: rem(48);
            }
        }
    }

    &__coins {
        cursor: pointer;
        @include on-desktop {
            margin-right: rem(24);
        }
    }

    &__track-wrapper {
        position: relative;
        width: urem(32);
        height: urem(32);
        flex-shrink: 0;

        @include on-desktop {
            width: urem(48);
            height: urem(48);
        }

        .icon-track {
            color: var(--color-primary);
            :deep(svg) {
                width: urem(32);
                height: urem(32);
            }
        }

        @include on-desktop {
            .icon-track {
                :deep(svg) {
                    width: urem(48);
                    height: urem(48);
                }
            }
        }

        .icon-promo-track {
            display: none;

            @include on-desktop {
                display: block;
                width: urem(316);
                height: urem(98);
                position: absolute;
                right: calc(100% - #{urem(25)});
                cursor: auto;
            }
        }

        .icon-close {
            width: urem(14);
            height: urem(14);
        }
    }

    &__track {
        cursor: pointer;
        position: relative;

        :deep(svg) {
            width: urem(32);
            height: urem(32);

            @include on-desktop {
                width: urem(48);
                height: urem(48);
            }
        }
    }

    &__track-close {
        display: none;

        @include on-desktop {
            display: block;
            cursor: pointer;
            position: absolute;
            top: calc(100% + #{urem(25)});
            right: calc(100% - #{urem(20)});
            padding: urem(5);
        }
    }

    &__impersonation {
        margin-top: mrem(40);
        @include on-desktop {
            margin-top: rem(40);
        }
    }

    &__logo-wrapper {
        display: flex;

        @include on-mobile {
            justify-content: flex-start;
            width: 100%;

            :deep(svg) {
                width: urem(61);
                height: urem(24);
            }
        }

        @include on-desktop {
            display: flex;
            justify-content: flex-end;
            margin: 0 auto;
        }
    }

    &__logo {
        display: flex;
        flex: 0 0 auto;
        width: urem(61);
        height: urem(24);

        @include on-desktop {
            width: urem(128);
            height: urem(49);
            margin: 0 auto;
            margin-right: rem(20);
        }
    }

    &__left {
        display: flex;
        align-items: center;
        flex-shrink: 0;

        @include on-desktop {
            width: auto;
            flex: 0;
        }
    }

    &__center {
        @include on-mobile {
            display: flex;
            justify-content: center;
            align-items: center;
            padding-left: 0;
            margin: 0 auto;
        }

        @include on-desktop {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-shrink: 0;
            margin: 0 auto;
            margin-left: rem(40);
        }

        .social-links {
            display: none;

            @include on-desktop {
                display: flex;
            }
        }

        &--no_margin {
            margin: 0;
        }

        &--authorized {
            margin-left: mrem(12);
            margin-right: auto;
        }
    }

    &__right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;

        @include on-desktop {
            width: auto;
            margin-right: mrem(25);
        }

        .search {
            display: none;

            @include on-desktop {
                display: flex;
            }
        }
    }

    &__icons {
        display: flex;
        gap: urem(16);
        color: var(--color-primary);

        @include on-desktop {
            gap: urem(24);
            margin-right: urem(40);
        }
    }

    &__element {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;

        @include on-desktop {
            font-size: rem(18);
        }

        svg {
            width: mrem(32);
            height: mrem(32);
        }

        @include on-desktop {
            svg {
                width: rem(48);
                height: rem(48);
            }
        }
    }

    .only-desktop {
        display: none;

        @include on-desktop {
            display: flex;
        }
    }

    &__buttons {
        flex: 0 1 auto;
    }

    .search.active {
        margin-left: rem(40);
        margin-right: rem(16);
    }
}

.no-wrap {
    white-space: nowrap;
}
</style>
